import { Box, Button, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";

type Colors = ReturnType<typeof tokens>;

export const filterPopoverPaperSx = (colors: Colors) => ({
  mt: "22px",
  p: "8px 11px 15px",
  bgcolor: colors.primary.bgChart,
  borderRadius: "8px",
  minWidth: "285px",
});

interface FilterSectionProps<T extends string> {
  label: string;
  onChange: (value: T) => void;
  options: Array<{ label: string; value: T }>;
  value: T;
}

export const FilterSection = <T extends string>({
  label,
  onChange,
  options,
  value,
}: FilterSectionProps<T>) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box display="flex" flexDirection="column" gap="10px">
      <Typography color={colors.primary.text} fontSize="10px" fontWeight={300}>
        {label}
      </Typography>
      <Box display="flex" alignItems="center" gap="8px" flexWrap="wrap">
        {options.map((option) => {
          const selected = value === option.value;
          return (
            <Button
              key={`${label}-${option.label}`}
              disableElevation
              onClick={() => onChange(option.value)}
              sx={{
                px: "16px",
                height: "26px",
                border: selected ? `1px solid ${colors.primary.activeText}` : `1px solid ${colors.primary[700]}`,
                borderRadius: "47px",
                bgcolor: selected ? colors.primary.activeText : colors.primary.bgChart,
                color: selected ? colors.primary.bg : colors.primary.grayText,
                fontSize: "11px",
                fontWeight: selected ? 800 : 500,
                textTransform: "none",
                "&:hover": {
                  bgcolor: selected ? colors.primary.activeText : colors.primary.bgChart,
                },
              }}
              variant="contained"
            >
              {option.label}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};
